export default __webpack_public_path__ + "static/media/PosLogo.8ac6607c.svg";